<template>
  <a-card :bordered='false'>
    <div class='table-page-search-wrapper'>
      <a-table
        ref='table'
        rowKey='id'
        size='middle'
        :columns='columns'
        :dataSource='dataSource'
        :pagination='false'
        :loading='loading'
        bordered>
        <!--        <template slot='action' slot-scope='text, record'>-->
        <!--         -->
        <!--        </template>-->
      </a-table>
      <div style='margin-top: 15px; text-align: right;'>
        <v-pagination
          v-if='total'
          :page-num='form.pageNum'
          :page-size='form.pageSize'
          :total='total'
          @change='handleTableChange' />
      </div>

    </div>
  </a-card>
</template>

<script>
import { filterObj } from '@/utils/util'
import { getallOrderList } from '@/webpublicapi/order'
import Dict from '../modules/Dict'
import DictSelect from '../modules/DictSelect'
import moment from 'moment'

const I18N_KEY = {
  ORDER: 'order.',
  CUSTOMER: 'customer.',
  APPROVAL: 'approval.'
}
export default {
  name: 'RepayLinkLog',
  components: {
    Dict,
    DictSelect
  },
  props: {
    orderId: {
      type: Number,
      default: undefined
    }
  },
  data() {
    return {
      paramsVal: {},
      I18N_KEY,
      visible: false,
      // 分页参数
      form: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      dataSource: [],
      // 查询条件
      queryParam: {
        'userName': '',
        'amount': '',
        'payAmount': '',
        'orderGenerationDate': []
      },
      loading: false,
      isorter: {
        column: 'createTime',
        order: 'desc'
      },
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('order.username'),
          align: 'left',
          dataIndex: 'userName'
        },
        {
          title: this.$t('order.appNameValue'),
          align: 'left',
          dataIndex: 'appName'
        },
        {
          title: this.$t('order.monayvalue'),
          align: 'left',
          dataIndex: 'amount'
        },
        {
          title: this.$t('order.orderallmoney'),
          align: 'left',
          dataIndex: 'payAmount'
        },
        {
          title: this.$t('order.createOrderDate'),
          align: 'left',
          dataIndex: 'createdTime'
        },
        {
          title: this.$t('order.repaymentLink'),
          align: 'left',
          dataIndex: 'linkUrl'
        }
        // {
        //   title: this.$t('action'),
        //   dataIndex: 'action',
        //   align: 'center',
        //   width: 370,
        //   scopedSlots: { customRender: 'action' }
        // }
      ]
    }
  },
  created() {
    this.loadData(1)
  },
  methods: {
    searchQuery() {
      this.loadData(1)
    },
    loadData(arg) {
      // 加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.form.pageNum = 1
      }

      var params = this.getQueryParams()// 查询条件
      params.orderInfoId = this.orderId
      console.log('params烦死了！！！！！！！！！！！', params)

      if (params == null) {

      } else {
        this.loading = true
        if (params.amount) {
          params.amount = parseInt(params.amount)
        }
        getallOrderList(Object.assign({}, params)).then((res) => {
          if (res.code === 1000) {
            console.log('res------->', res)
            this.dataSource = res.data.rows.list
            this.total = res.data.rows.total
          } else {
            this.total = 0
            this.dataSource = []
            this.$message.error(res.msg)
          }
          this.loading = false
        }).catch(e => {
          this.loading = false
          this.$message.error(e.message)
        })
      }
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    transformStringToLow(str) {
      return str && str.toLocaleLowerCase()
    },
    getQueryParams() {
      const { orderGenerationDate } = this.queryParam
      console.log('orderGenerationDate', orderGenerationDate)
      if (orderGenerationDate.length) { //不能都选
        this.paramsVal = {
          ...this.queryParam,
          startTime: orderGenerationDate && this.transformTime(orderGenerationDate[0]),
          endTime: orderGenerationDate && this.transformTime(orderGenerationDate[1])
        }
      } else {
        console.log('时间没筛选')
        this.paramsVal = {
          ...this.queryParam
        }
      }
      //分页参数
      this.paramsVal.pageNum = this.form.pageNum
      this.paramsVal.pageSize = this.form.pageSize
      delete this.paramsVal.orderGenerationDate
      return filterObj(this.paramsVal)
    },

    handleTableChange(pageNum, pageSize) {
      this.form.pageNum = pageNum
      this.form.pageSize = pageSize
      this.loadData()
    },
    // 重置字典类型搜索框的内容
    searchReset() {
      var that = this
      that.queryParam.userName = ''
      that.queryParam.orderGenerationDate = []//[moment().add('days'), moment().add('days', 0)]
      that.queryParam.amount = ''
      that.queryParam.payAmount = ''
      that.loadData(this.form.pageNum)
    }
  }
}
</script>
<style lang='less' scoped>
@import "~@/assets/less/common.less";
</style>
